import { useMemo } from "react";

export default function useBeforeEffect(func, deps) {
  useMemo(func, deps);
}
